<template>
  <div class="domain-cell">
    <div class='content-domain-and-asset'>
      <div class="domain-value" :domain='domain'>
        {{ domain }}
      </div>
      <div class="asset-value" :title='asset'>
        {{ asset }}
      </div>
    </div>
  </div>
</template>

<script>
import actionToTakeTable from '@/mixins/actionToTakeTable';

export default {
  name: 'AffectedAssetTableCell',
  mixins: [actionToTakeTable],
  computed: {
    domain() {
      return this.item[this.column.field].domain;
    },
    asset() {
      return this.item[this.column.field].asset;
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.domain-cell {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content-domain-and-asset {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.domain-value{
  color: var(--text-primary);
  display: flex;
  font-family: $font-family-bold;
  font-size: rem(14);
  font-weight: bold;
  letter-spacing: 0;
  line-height: rem(17);
}

.asset-value {
  color: var(--text-primary);
  font-family: $font-family-regular;
  font-size: rem(12);
  letter-spacing: 0;
  line-height: rem(15);
  max-width: rem(2200);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
